import React from "react";
import Root from "./views/Root";

const App: React.FC = () => {
  return (
    <div>
      <Root />
    </div>
  );
};

export default App;
